import { TableHead, TableHeader, TableRow } from '@/components/ui';

export const DataTableHeader = () => (
	<TableHeader>
		<TableRow>
			<TableHead className="w-[150px]">Date</TableHead>
			<TableHead className="w-[110px]">Action</TableHead>
			<TableHead className="w-[200px]">Type</TableHead>
			<TableHead className="w-[160px]">Entity ID</TableHead>
			<TableHead>Effectué par</TableHead>
			<TableHead className="w-[80px] text-right">Snapshot</TableHead>
		</TableRow>
	</TableHeader>
);
